import { type ReactNode } from 'react';
import { Flex } from '@radix-ui/themes';
import { PwaInstallPrompt } from '@/components/common';

/** Portal target for overlays (modals, dialogs, etc.) — phone column, not the viewport. */
export const APP_SHELL_PORTAL_ID = 'app-shell-portal';

interface AppShellProps {
  children: ReactNode;
}

/** Full viewport on phone; centered 60vw phone column on lg+ (capped height, shrinks on short viewports). */
export function AppShell({ children }: AppShellProps) {
  return (
    <Flex
      direction="column"
      width={{ initial: '100vw', md: '60vw' }}
      height="100vh"
      mx="auto"
      id={APP_SHELL_PORTAL_ID}
    >
      <PwaInstallPrompt />
      {children}
    </Flex>
  );
}
